import React, { FunctionComponent, ReactNode, SVGProps } from 'react';

import './SidebarNavItem.scss';

interface SidebarNavItemProps {
  icon: FunctionComponent<SVGProps<SVGSVGElement> & { title?: string }>;
  iconTitle: string;
  label: string;
  isExpanded: boolean;
  active?: boolean;
  trailing?: ReactNode;
  ariaExpanded?: boolean;
  onClick: () => void;
}

const SidebarNavItem = ({
  icon: Icon,
  iconTitle,
  label,
  isExpanded,
  active = false,
  trailing,
  ariaExpanded,
  onClick
}: SidebarNavItemProps) => {
  const classNames = ['sidebar-nav-item', isExpanded ? 'expanded' : '', active ? 'active' : '']
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type="button"
      className={classNames}
      onClick={onClick}
      aria-current={active ? 'page' : undefined}
      aria-expanded={ariaExpanded}
      aria-label={isExpanded ? undefined : label}
    >
      {active && !isExpanded && <span className="sidebar-nav-item-indicator" data-testid="active-indicator" />}
      <Icon className="sidebar-nav-item-icon" title={iconTitle} />
      {isExpanded && <span className="sidebar-nav-item-label">{label}</span>}
      {isExpanded && trailing}
    </button>
  );
};

export default SidebarNavItem;
